/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
export default new Vue();